import { useState, useEffect } from "react"
import Select from "../../components/ui/select/select"

const CALENDAR_MONTHS = {
	0: "January",
	1: "February",
	2: "March",
	3: "April",
	4: "May",
	5: "June",
	6: "July",
	7: "August",
	8: "September",
	9: "October",
	10: "November",
	11: "December",
}

export default function DateSelector({ onDateChange, onYearsToCompareChange }) {
	const currentYear = new Date().getFullYear()
	const currentMonth = new Date().getMonth()

	const [selectedYear, setSelectedYear] = useState(currentYear.toString())
	const [selectedMonth, setSelectedMonth] = useState(currentMonth.toString())
	const [yearsToCompare, setYearsToCompare] = useState("1")

	// Generate year options (from 2020 to current year)
	const yearOptions = {}
	for (let year = 2020; year <= currentYear; year++) {
		yearOptions[year.toString()] = year.toString()
	}

	const compareYearsOptions = {
		1: "1 Previous Year",
		2: "2 Previous Years",
		3: "3 Previous Years",
		4: "4 Previous Years",
		5: "5 Previous Years",
	}

	// Notify parent of changes
	useEffect(() => {
		onDateChange({
			viewMode: "month",
			year: parseInt(selectedYear),
			month: parseInt(selectedMonth),
		})
	}, [selectedYear, selectedMonth, onDateChange])

	useEffect(() => {
		onYearsToCompareChange(parseInt(yearsToCompare))
	}, [yearsToCompare, onYearsToCompareChange])

	return (
		<div className="page-filters charting">
			<Select
				label="Month:"
				placeholder="Month:"
				value={CALENDAR_MONTHS[selectedMonth]}
				activeOnHover={true}
				onSelect={(option) => setSelectedMonth(option.option)}
				options={CALENDAR_MONTHS}
			/>

			<Select
				label="Year:"
				placeholder="Year:"
				value={selectedYear}
				activeOnHover={true}
				onSelect={(option) => setSelectedYear(option.option)}
				options={yearOptions}
			/>

			<Select
				label="Compare Years:"
				placeholder="Compare Years:"
				value={compareYearsOptions[yearsToCompare]}
				activeOnHover={true}
				onSelect={(option) => setYearsToCompare(option.option)}
				options={compareYearsOptions}
			/>
		</div>
	)
}
